import Routes from "@navigations/Routes";
import { isEmbeddedFrame, postIframeLayout } from "@utils/iframeMessaging";
import { isShownScreen } from "./contentBounds";

const MIN_CHANGE = 2;

export const SEARCH_EMPTY_ROOT_ID = "iframe-results-empty";

// The "no results" state replaces the result list, so the list's height
// watcher has nothing to measure. Size the iframe to this message instead.
export const initializeSearchEmptyHeight = (
  getRoot: () => HTMLElement | null
) => {
  if (!isEmbeddedFrame()) return () => undefined;

  let active = true;
  let lastPosted = 0;
  let frameId = 0;

  const publish = () => {
    if (!active) return;
    const root = getRoot();
    if (!root || typeof root.getBoundingClientRect !== "function") return;
    if (!isShownScreen(root)) return;
    const marginBottom =
      parseFloat(window.getComputedStyle(root).marginBottom) || 0;
    const height = Math.ceil(
      root.getBoundingClientRect().bottom + window.scrollY + marginBottom
    );
    if (height <= 0 || Math.abs(height - lastPosted) < MIN_CHANGE) return;
    lastPosted = height;
    postIframeLayout({
      mode: "auto-height",
      route: Routes.SearchResultScreen,
      height,
    });
  };

  const schedule = () => {
    cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(publish);
  };

  const resizeObserver = new ResizeObserver(schedule);
  const root = getRoot();
  if (root) resizeObserver.observe(root);
  window.addEventListener("resize", schedule);
  schedule();

  return () => {
    active = false;
    cancelAnimationFrame(frameId);
    resizeObserver.disconnect();
    window.removeEventListener("resize", schedule);
  };
};
